import { createTheme } from '@mui/material/styles';

const TripengerTheme = createTheme({
  typography: {
    fontSize: 14,
    fontFamily: 'Urbanist, Arial, sans-serif',
    h1: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '2rem',
      fontWeight: 600,
    },
    h2: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h4: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h5: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '1.1rem',
      fontWeight: 600,
    },
    h6: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '1rem',
      fontWeight: 600,
    },
    subtitle1: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '0.9375rem',
    },
    subtitle2: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '0.875rem',
    },
    body1: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '0.875rem',
    },
    body2: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '0.8125rem',
    },
    button: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    caption: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '0.75rem',
    },
    overline: {
      fontFamily: 'Urbanist, Arial, sans-serif',
      fontSize: '0.75rem',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
          color: '#fff'
        },
        textPrimary: {
          backgroundColor: '#00AFED',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#548cc9',
          },
        },
        textSecondary: {
          backgroundColor: '#051d3f',
          color: '#fff',
          '&:hover, &:active, &:focused': {
            backgroundColor: 'inherit',
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#00AFED',
      light: '#548cc9',
      dark: '#0f4e92',
    },
    secondary: {
      main: '#051d3f',
      light: '#6684ae',
      dark: '#01142f',
    },
  },
});

export default TripengerTheme;
